/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Student_PaidInputs */

const en_student_paid = /** @type {(inputs: Student_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`paid`)
};

const he_student_paid = /** @type {(inputs: Student_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שולם`)
};

/**
* | output |
* | --- |
* | "paid" |
*
* @param {Student_PaidInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const student_paid = /** @type {((inputs?: Student_PaidInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Student_PaidInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_student_paid(inputs)
	return he_student_paid(inputs)
});